module.exports = window["ReactRefreshRuntime"];